import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import aquilaLogo from "../assets/aquilaLogo.svg";
import api from "../api";
import { useAuth } from "../context/authContext";
import chevronDown from "../assets/chevron_down.svg";
import userIcon from "../assets/userIcon.svg";
import doorIcon from "../assets/doorIcon.svg";
import TableroIcon from "./icons/TableroIcon";
import CotizadorIcon from "./icons/CotizadorIcon";
import ReportesIcon from "./icons/ReportesIcon";
import ClientesIcon from "./icons/ClientesIcon";
import ConductoresIcon from "./icons/ConductoresIcon";
import VehiculosIcon from "./icons/VehiculosIcon";
import UsuariosIcon from "./icons/UsuariosIcon";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { FiMenu } from "react-icons/fi";
import { FiX } from "react-icons/fi";

export default function Layout({ children }) {
  const { signOut } = useAuth();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [user, setUser] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleLogout = async () => {
    await signOut();
  };

  const handleProfile = () => {
    navigate("/profile");
  };

  useEffect(() => {
    async function fetchMe() {
      try {
        const response = await api.users.getMe();
        setUser(response);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }
    fetchMe();
  }, []);

  return (
    <div className="flex h-screen w-full">
      {/* Sidebar */}
      {user?.role !== undefined && (
        <div
          className={`${
            isSidebarCollapsed ? "w-16" : "w-1/6 "
          } bg-[#F1F2F7] text-[#C4C7DB] p-4 border-r border-gray-300 max-h-screen transition-all duration-300`}
        >
          {/* Logo */}
          <div
            className={`flex justify-between items-center mb-6 ${
              !isSidebarCollapsed ? "md:px-8" : ""
            }`}
          >
            {!isSidebarCollapsed && <img src={aquilaLogo} alt="Logo" />}
            {/* Botón de colapso */}
            <button
              className="hidden md:block p-2 text-gray-600 hover:text-gray-900"
              onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            >
              {isSidebarCollapsed ? <FiMenu size={20} /> : <FiX size={20} />}
            </button>
          </div>

          {/* Menú */}
          <nav className="space-y-4 mt-4 md:p-8 text-[rgba(8,36,49,0.4)] text-sm flex flex-col">
            <h2
              className={`poppins-bold text-xs mb-4 ${
                isSidebarCollapsed ? "hidden" : "block"
              }`}
            >
              MENÚ
            </h2>

            {[
              { path: "/rides", label: "Tablero", Icon: TableroIcon },
              { path: "/quoter", label: "Cotizador", Icon: CotizadorIcon },
              ...(user.role === 2
                ? [{ path: "/reports", label: "Reportes", Icon: ReportesIcon }]
                : []),
              { path: "/clients", label: "Clientes", Icon: ClientesIcon },
              { path: "/drivers", label: "Conductores", Icon: ConductoresIcon },
              { path: "/cars", label: "Vehículos", Icon: VehiculosIcon },
              ...(user.role === 2
                ? [{ path: "/users", label: "Usuarios", Icon: UsuariosIcon }]
                : []),
            ].map(({ path, label, Icon }) => (
              <div
                key={path}
                className="poppins-medium flex flex items-center gap-x-3 cursor-pointer"
                onClick={() => navigate(path)}
              >
                <Icon
                  size={20}
                  color={location.pathname === path ? "#D35B66" : "#C4C7DB"}
                />
                {!isSidebarCollapsed && (
                  <span
                    className={`hidden md:block text-left p-2 rounded ${
                      location.pathname === path ? "text-[#D35B66]" : ""
                    }`}
                  >
                    {label}
                  </span>
                )}
              </div>
            ))}
          </nav>
        </div>
      )}

      {/* Contenido principal */}
      <div className="flex flex-col flex-1 tracking-wider">
        {/* Barra superior */}
        <div className="flex items-center justify-between bg-[#F8F9FB] p-4 border-b border-gray-300">
          {/* Espaciador para mantener alineado el botón de usuario */}
          <div></div>

          {/* Selector de rol */}
          <div className="relative">
            <button
              onClick={() => setIsPopupOpen((prev) => !prev)}
              className="poppins-regular bg-transparent text-xs text-[#1F384C] py-2 px-4 rounded-lg flex items-center"
            >
              {user.role === 2 ? "Administrador" : "Coordinador"}{" "}
              <img className="ml-2" src={chevronDown} alt="flecha abajo" />
            </button>
            {isPopupOpen && (
              <div className="absolute right-0 top-12 bg-white border shadow-lg rounded-lg w-[200px] p-2">
                <button
                  className="flex items-center pl-5 cursor-pointer"
                  onClick={handleProfile}
                >
                  <img src={userIcon} alt="Icono de perfil" className="mr-2" />
                  <p className="inter-regular block w-full text-left text-xs text-[#2C2C2C] px-4 py-2">
                    Perfil
                  </p>
                </button>
                <button
                  className="flex items-center pl-5 cursor-pointer"
                  onClick={handleLogout}
                >
                  <img
                    src={doorIcon}
                    alt="Icono de cerrar sesión"
                    className="mr-2"
                  />
                  <p className="inter-regular block w-full text-left px-4 py-2 text-xs text-[#BE202F]">
                    Cerrar Sesión
                  </p>
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Contenido dinámico */}
        <div className="flex-grow p-8 bg-[#F8F9FB] overflow-y-auto h-full">
          {children}
        </div>
      </div>
    </div>
  );
}
